const PopupConstants = {
  ACTIVATE_NEXT_UNFILLED_POPUP: 'ACTIVATE_NEXT_UNFILLED_POPUP',
  ACTIVE_POPUP_SET: 'ACTIVE_POPUP_SET',
  ATTACH_TO_MOUSE_SET: 'ATTACH_TO_MOUSE_SET',
  CHANGE_POPUP: 'CHANGE_POPUP',
  CLEAR_ACTIVE_POPUP: 'CLEAR_ACTIVE_POPUP',
  CREATE_POPUP: 'CREATE_POPUP',
  DELETE_POPUP: 'DELETE_POPUP',
  DELETE_SHARE_POPUPS: 'DELETE_SHARE_POPUPS',
  EDIT_POPUP_END: 'EDIT_POPUP_END',
  EDIT_POPUP_START: 'EDIT_POPUP_START',
  GROUP_POPUP_DELETE: 'GROUP_POPUP_DELETE',
  MOVE_POPUP: 'MOVE_POPUP',
  POPUP_DIRECT_SELECT: 'POPUP_DIRECT_SELECT',
  POPUP_IMAGE_LOADED: 'POPUP_IMAGE_LOADED',
  SET_Z_INDEX: 'SET_Z_INDEX',
  SIGNATURE_POPUP_CLEAR: 'SIGNATURE_POPUP_CLEAR',
  UNWRAP_REQUEST_SIGNATURE_POPUPS: 'UNWRAP_REQUEST_SIGNATURE_POPUPS',
  UPDATE_REQUEST_SIGNATURE_CONTENT: 'UPDATE_REQUEST_SIGNATURE_CONTENT',
};

export const SelfServeBuilderPopupTypes = {
  TEXTBOX: 'SELF_SERVE_BUILDER_TEXTBOX',
  MULTIPLE_CHOICE: 'SELF_SERVE_BUILDER_MULTIPLE_CHOICE',
  CHECKBOX: 'SELF_SERVE_BUILDER_CHECKBOX',
  SIGNATURE: 'SELF_SERVE_BUILDER_SIGNATURE',
};

export const toolboxItemTypeToTracking = {
  [SelfServeBuilderPopupTypes.CHECKBOX]: 'Checkbox',
  [SelfServeBuilderPopupTypes.MULTIPLE_CHOICE]: 'Multiple Choice',
  [SelfServeBuilderPopupTypes.SIGNATURE]: 'Signature',
  [SelfServeBuilderPopupTypes.TEXTBOX]: 'Textbox',
};

export const ImageTypes = {
  SIGNATURE: 'signature',
};

export const PopupTypes = {
  ERASER: 'eraser',
  HIGHLIGHTER: 'highlighter',
  IMAGE: 'image',
  REDACT: 'redact',
  REQUEST_SIGNATURE: 'request-signature',
  TEXT: 'text',
};

export default PopupConstants;



// WEBPACK FOOTER //
// ./src-react/Popups/PopupConstants.jsx